import { useContext } from 'react'
import ConfirmAlert  from '../../../component/confirmAlert'
import { DomainContext } from '../../../context/DomainContext'
import { succToast } from '../../../utils'

export const useBaseHook = (api) => {
     const { setLoading, ToggleReloadTable } = useContext(DomainContext)

    const onApply = (msg, reqBody) => {
        ConfirmAlert(msg,
            () => {
                setLoading(l => l + 1)
                api?.(reqBody)?.then(res => {
                    ToggleReloadTable(prev => !prev)
                    succToast("Operation done successfully")
                })?.finally(() =>
                     setLoading(l => l - 1)
                    )
            })
    }

    return { onApply }
}
